import { RE2JS } from 're2js';

import { searchRegexLanguageParser } from './parser';
import { SearchQueryTermWithoutPositions } from './types';

export function isValidSearchQuery(input: SearchQueryTermWithoutPositions[] | string) {
  let serialized: string;

  if (typeof input === 'string') {
    serialized = input;
  } else {
    serialized = searchRegexLanguageParser.serialize(input);
  }

  const { status } = searchRegexLanguageParser.parse(serialized);
  return status === 'valid' || status === 'partial';
}

export const escapeTextToEquivalentRegexp = (text: string) => RE2JS.quote(text);
